import apiFetch from '../apiFetch'

export default function (documentId, token) {
  return apiFetch({ endPoint: `document/${documentId}/visor`, method: 'GET', body: null, token: token })
}
